import { Link } from 'react-router';
import { EntityTooltip } from '../site/Tooltip';
import { Icon24 } from '../ui/Icon';
import css from "./SkillList.module.css";
import { useTurl } from '~/util/Lang';

type NpcSkill = {
  id: number;
  cardName: string,
  icon: string;
  skillName: string;
  name: string;
  level: number | null;
  operateType: "P" | "A1" | "A2" | "A3" | "T" | "DA1" | "DA2" | "CA1" | "CA5";
};
export function SkillList(props: { skills: NpcSkill[]; }) {
  const turl = useTurl();
  return <div className={css.root}>{props.skills.map((s, i) =>
    <EntityTooltip
      key={i}
      what={{ t: "skill", uname: `${s.id}_${s.level}` }}
    >
      {({ setReference, getReferenceProps }) => (
        <div
          ref={setReference}
          {...getReferenceProps({
            style: {
              display: "flex",
            },
          })}
        >
          <Link
            to={turl(`/skills/${s.cardName}:${s.level ?? 1}`)}><Icon24 icon={s.icon} alt={s.name} canBeUsed={s.operateType !== "P"} /></Link>
        </div>
      )}
    </EntityTooltip>

  )}</div>;
}